document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener("change", applyKlaviyoHandler);
  
  document.addEventListener('click', function(event) {
    const target = event.target;
    if (target.matches('[name="checkout"], [name="goto_pp"], [name="goto_gc"]')) {
      const agreeCheckbox = document.getElementById('agree');
      if (agreeCheckbox.checked) {
        event.target.form.submit();
      } else {
        alert(Shopify.translations.cartAcceptTerms);
        event.preventDefault();
      }
    }
  });
});

const applyKlaviyoHandler = () => {
  const selectedVariantInput = document.querySelector('.variant-picker__option-values input:checked');
  const bisTriggerButton = document.querySelector('.btn.klaviyo-bis-trigger');

  if (selectedVariantInput) {
    const label = selectedVariantInput.nextElementSibling; // Get the adjacent label

    if (label && label.classList.contains('is-disabled')) {
      bisTriggerButton.style.display = 'block';
    } else {
      bisTriggerButton.style.display = 'none';
    }
  } else {
    bisTriggerButton.style.display = 'none'; // Hide if no variant is selected
  }
};
